@use "../../styles/breakpoint.module.scss" as *;

// Container height is fixed based on center image aspect ratio so
// side images can be shorter within the same space.
.carousel {
    position: relative;
}

.carouselScroll {
    --carousel-center-width: 78vw;
    --carousel-height: calc(var(--carousel-center-width) * 9 / 16);
    --carousel-side-height: calc(var(--carousel-height) * 0.9);
    --carousel-side-padding: calc((100vw - var(--carousel-center-width)) / 2);

    scroll-snap-type: x mandatory;
    scroll-padding-inline: var(--carousel-side-padding);
    height: var(--carousel-height);

    @media ($below-tablet) {
        --carousel-center-width: calc(
            100vw - 2 * var(--labui-container-margin)
        );
        --carousel-height: calc(100vw * 5 / 4);
        --carousel-side-padding: var(--labui-container-margin);
    }
}

.carouselSlidesWrapper {
    width: max-content;
    padding-inline: var(--carousel-side-padding);
    height: 100%;
}

// The base Carousel uses inline-block slides, so we use vertical-align
// for centering and margin-inline for gaps between slides.
.carouselSlide {
    scroll-snap-align: center;
    width: var(--carousel-center-width);
    overflow: hidden;
    vertical-align: middle;
    margin-inline: var(--spacer-12);
    transition:
        opacity 0.2s ease-in-out,
        height 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
    height: var(--carousel-side-height);
    opacity: 0.4;

    &:not([inert]) {
        height: var(--carousel-height);
        opacity: 1;
    }

    @media ($below-tablet) {
        margin-inline: var(--labui-container-margin);
        height: var(--carousel-height);
        opacity: 1;
    }
}

.carouselImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.carouselDots {
    display: none;

    @media ($below-tablet) {
        display: flex;
        position: static;
        transform: none;
        justify-content: center;
        margin-top: var(--spacer-16);
    }
}

.carouselControls {
    position: absolute;
    inset: 0 var(--labui-container-margin);
    display: flex;
    align-items: center;
    justify-content: space-between;
    pointer-events: none;

    > * {
        pointer-events: auto;
    }

    @media ($below-tablet) {
        display: none;
    }
}

.caption {
    padding-left: calc((100vw - 78vw) / 2);
    padding-right: var(--labui-container-margin);
    margin-top: var(--spacer-block-small);

    @media ($below-tablet) {
        padding-inline: var(--labui-container-margin);
        text-align: center;
    }
}
